<template>
	<slot :current-item="currentItem" :change-current-item="changeCurrentItem"></slot>
</template>

<script setup>
import { ref } from 'vue'

const currentItem = ref(0)

const changeCurrentItem = (index) => {
  currentItem.value = index
}
</script>